import ApiServer from "../../ApiServer.js";
import * as FwDatas from "../../FwDatas.ts";
import * as i18n from "../../i18n.ts";
import * as amplify from "../../util/amplify.ts";
import * as Storage from "../../lib/Storage.ts";
import IHasRecurrencyHelper from "../../lib/IHasRecurrencyHelper.js"
import * as DateUtils from "../../lib/DateUtils.ts"
import {SyncCache} from "../../lib/SyncCache.ts";

export {getCache,setCurrentBudget,getCurrentBudget,buildTransactionList,buildSummary}
function compareName(a,b){
  //TODO understand why using a.name.localCompare(b.name) causes : TypeError: a.name.localCompare is not a function
   return String.prototype.localeCompare.apply(a.name,[b.name])
}
function compareSortingIndex(a,b){
   return a.sortingIndex-b.sortingIndex
}

const 
  budgetCache = new SyncCache(ApiServer.budgetsync,compareName),
  budgetCategoryCache = new SyncCache(ApiServer.budgetcategorysync,compareSortingIndex),
  budgetPaymentMethodCache = new SyncCache(ApiServer.budgetpaymentmethodsync,compareSortingIndex),
  budgetTransactionCache = new SyncCache(ApiServer.budgettransactionsync);

function getCache(){
  return {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache}
}

function getlang(){
  var lang = i18n.getShortLanguage();
  if(['en','fr','de','nl','es','pt','it','ja','ru'].indexOf(lang)===-1){
    lang = 'en'
  }
  return lang;
}

budgetCategoryCache.filtered = function(){
  var lang = getlang();
  return budgetCategoryCache.datas.filter(cat=>(!cat.hidden || cat.default) && (cat.locale===undefined ||cat.locale===lang))
}
budgetCategoryCache.hidden = function(){
  var lang = getlang();
  return budgetCategoryCache.datas.filter(cat=>(cat.hidden && !cat.default) && (cat.locale===undefined ||cat.locale===lang))
}

budgetPaymentMethodCache.filtered = function(){
  var lang = getlang();
  return budgetPaymentMethodCache.datas.filter(cat=>(!cat.hidden || cat.default) && (cat.locale===undefined ||cat.locale===lang))
}
budgetPaymentMethodCache.hidden = function(){
  var lang = getlang();
  return budgetPaymentMethodCache.datas.filter(cat=>(cat.hidden && !cat.default) && (cat.locale===undefined ||cat.locale===lang))
}
amplify.subscribe("budgetNeedRefresh",function(){
  refreshAll().then(function(){
    amplify.publish("budgetRefreshed")
  })
});  
function refreshAll(){
  return new Promise((accept,reject)=>{
    budgetCache.refresh()
    budgetCategoryCache.refresh()
    budgetPaymentMethodCache.refresh()
    budgetTransactionCache.refresh()
    ApiServer.aftergroup(accept)
    //FIXME reject should be somewhere
  })
}

Object.assign(ApiServer.types.BudgetBean.prototype,{
  onDecode(){
    this.formatter = new Intl.NumberFormat(i18n.getSelectedLanguage(), {
      style: 'currency',
      currency: this.currencyCode
    });
    this.formatterRound = new Intl.NumberFormat(i18n.getSelectedLanguage(), {
      style: 'currency',
      currency: this.currencyCode,
      maximumFractionDigits:0,
      minimumFractionDigits:0
    });
    this.isRecurrent = this.recurrencyDescriptor.recurrency!=='NONE';
    this.sharingType = this.sharedToAll?'all':(this.sharedMemberIds.length>1?'custom':'none')
    this.rights.canShare = this.accountId === FwDatas.getAccountId()

    var 
      template = this.formatterRound.format(0).split(/0/g);
    this.beforeAmount = template[0];
    this.afterAmount = template[1];
    
  },
  isCategoryLimitValid(){
    return this.budgetLimit>= Object.values(this.budgetCategoryLimits).reduce((prev,current)=>prev+current,0)
  },
  formatAmount(amount){
    if(isNaN(amount)) return null;
    return this.formatter.format(amount)
  },
  formatAmountRound(amount){
    if(isNaN(amount)) return null;
    return this.formatterRound.format(amount)
  },
  getTransactionList(range = IHasRecurrencyHelper.getRange(this.recurrencyDescriptor.recurrency,new Date()),filter={}){
    var budgetTransactions = budgetTransactionCache.datas.filter(t=>t.budgetId===this.metaId);
    return buildTransactionList(range,budgetTransactions)
  },
  getRange(date){
    if(this.recurrencyDescriptor.recurrency==="NONE"){
      return  IHasRecurrencyHelper.getRange(this.recurrencyDescriptor.recurrency,date)
    } 
    if(this.recurrencyDescriptor.recurrency==="BIWEEKLY"){
      return DateUtils.getWeekRange(date,this.recurrencyStartDay,2);
    } 
    
    const START = DateUtils.clearTime(date)
    START.setFullYear(START.getFullYear()-2)
    //TODO put this in IHasRecurrencyHelper.getRange(
    if(this.recurrencyDescriptor.recurrency==="BIWEEKLY"){
      START.setMonth(0)
      START.setDate(this.recurrencyStartDay)
    }
    var 
      allDates = IHasRecurrencyHelper.listInterval({startDate:START,allDay:true,recurrencyDescriptor:this.recurrencyDescriptor},{start:START,end:date},1).map(interval=>interval.start),
      start = allDates[allDates.length-2],
      end = allDates[allDates.length-1],
      prev = new Date(start.getTime()-1000),
      next = new Date(end.getTime()),
      rangeTextEnd = new Date(end.getTime());
    next.setDate(next.getDate()+1)
    rangeTextEnd.setDate(rangeTextEnd.getDate()-1)
    
    var name = DateUtils.dayRangeString(start,rangeTextEnd);
    return new DateUtils.DateRange({
      start:start,
      end:end,
      prev:prev,
      next:next,
      recurrency:this.recurrencyDescriptor.recurrency,
      name:name
    })
  }
})

Object.assign(ApiServer.types.BudgetTransactionBean.prototype,{
  onDecode(){
    FwDatas.cache(this);
    this.isExpense = (this.budgetTransactionType==="EXPENSE");
    var now = new Date();
    this.isUpcoming = this.startDate>now && !DateUtils.isSameDay(now,this.startDate);
  },
  isPaid(){
    return this.paidOccurence.indexOf(this.occurence||0)!==-1
  },
  budgetCategory(){
    return FwDatas.get(this.budgetCategoryId);
  },
  budget(){
    return FwDatas.get(this.budgetId);
  },
  paymentMethod(){
    return FwDatas.get(this.paymentMethodId);
  },
  relatedAccount(){
    return FwDatas.getProfile(this.relatedAccountId);
  },
  amountString(){
    var str = this.budget().formatAmount(-this.amount)
    if(this.budgetTransactionType==="EXPENSE"){
      return str;
    }else{
      return str.replace('-','+')
    }
  }
});


Object.assign(ApiServer.types.BudgetCategoryBean.prototype,{
  onDecode(){
    if(this.emoji===undefined){
      this.emoji='💰'
    }
    FwDatas.cache(this)
  },
  compareTo(another){
    return this.name.localeCompare(another.name)
  }
});
Object.assign(ApiServer.types.PaymentMethodBean.prototype,{
  onDecode(){
    if(this.emoji===undefined){
      this.emoji='💰'
    }
    FwDatas.cache(this)
  },
  compareTo(another){
    return this.name.localeCompare(another.name)
  }
});

function setCurrentBudget(budgetId){
  Storage.localSet('budget.current',budgetId)
}
function getCurrentBudget(){
  var 
    metaId = Storage.localGet('budget.current'),
    budget = FwDatas.get(metaId);
    
  if(!budget){
    budget  = budgetCache.datas.filter(t=>t.metaId===Storage.localGet('budget.current'))[0]||budgetCache.datas[0];
  }
  return budget;
}

function buildTransactionList(range,transactionList){
  var result = [];
  transactionList.forEach(transaction=>{
    var 
      rrule = transaction.recurrencyDescriptor.rrule;
    if(rrule){
      IHasRecurrencyHelper.listInterval(transaction,range).forEach(t=>{
        FwDatas.cache(t)
        t.startDate = t.start;
        result.push(t);
      })
      
    }else if(transaction.startDate>=range.start && transaction.startDate<range.end){
      result.push(transaction);
    }
    
  })
  return result;
}
function buildSummary(budget,transactionList){
  var 
    balance = 0,revenue =0,expense =0,expenseByCat={},expenseByUser={};
  
  if(budget.paidUsage ==='PAID'){
    transactionList = transactionList.filter(transaction=>transaction.isPaid())
  }
  if(transactionList.length===0){
    return {
      balance : balance,
      balanceString : budget.formatAmount(balance),
      revenue : revenue,
      revenueString : budget.formatAmount(revenue),
      expense : expense,
      expenseString : budget.formatAmount(expense),
      
      topCategoryTitle : null,
      topCategory : 0,
      topCategoryString : budget.formatAmount(0),
      topPayerTitle : null,
      topPayer : 0,
      topPayerString : budget.formatAmount(0)
    }  
  }
  
  transactionList.forEach(transaction=>{
    if(transaction.budgetTransactionType==="EXPENSE"){
      balance -= transaction.amount;
      expense += transaction.amount;
      expenseByCat[transaction.budgetCategoryId] = (expenseByCat[transaction.budgetCategoryId]||0)+transaction.amount;
      expenseByUser[transaction.relatedAccountId] = (expenseByUser[transaction.relatedAccountId]||0)+transaction.amount;
    }else{
      balance += transaction.amount;
      revenue += transaction.amount;
    }
  })  
  
  let 
    expenseByCatEntries = Object.entries(expenseByCat),
    topPayerEntries = Object.entries(expenseByUser),
    topCategory = expenseByCatEntries.length===0?[]:expenseByCatEntries.reduce((previousEntry, currentEntry)=>{
      return previousEntry[1]<currentEntry[1]?currentEntry:previousEntry}
      ,expenseByCatEntries[0]),
    topPayer = topPayerEntries.length===0?[]:topPayerEntries.reduce((previousEntry, currentEntry)=>{
      return previousEntry[1]<currentEntry[1]?currentEntry:previousEntry}
      ,topPayerEntries[0]);
  
  function roundIfOk(amount){
    if(Math.round(amount)===amount){
      return budget.formatAmountRound(amount)
    }else{
      return budget.formatAmount(amount)
    }
  }
  var topCategoryCached = FwDatas.get(topCategory[0])
  return {
    balance : balance,
    balanceString : roundIfOk(balance),
    revenue : revenue,
    revenueString : roundIfOk(revenue),
    expense : expense,
    expenseString : roundIfOk(expense),
    
    topCategoryTitle : topCategoryCached?topCategoryCached.name:null, //should never happen!!
    topCategory : topCategory[1],
    topCategoryString : roundIfOk(topCategory[1]),
    topPayerTitle : FwDatas.getProfile(topPayer[0]).name,
    topPayer : topPayer[1],
    topPayerString : roundIfOk(topPayer[1])
  }  
}

/*
var lastStart;
for(var date=new Date('2020-1-1');date<new Date('2040-12-31');){
  var range = DateUtils.getWeekRange(date,7,2);
  date = range.next;
  if(lastStart!==undefined){
    var lastStartIncremented = new Date(lastStart)
    lastStartIncremented.setDate(lastStart.getDate()+14);
    console.log(range.start.getTime()===lastStartIncremented.getTime());
  }
  lastStart = range.start;
}*/